import {
  dateOperating
} from '@/cllib/tools'

// 最佳入库比例
const optimalStorageRatio = 0.8

// 每天工作市场
const workHours = 13

export const hourLong = 1000 * 60 * 60

export const calculateArriveTimeByVolume = (hourStatus, canChoosePeriod, volume) => {
  volume = volume || 1
  let arriveTime = null
  // 可用小时状态列表
  let canChooseHourStatus = getCanChooseHourStatus(hourStatus, canChoosePeriod)
  if (canChooseHourStatus.length === 0) {
    return arriveTime
  }
  // 待选到达时间
  let minRate = null
  canChooseHourStatus.forEach((item) => {
    let rate = volume / item.emptyInventory - optimalStorageRatio
    rate = rate * rate
    minRate = minRate || (rate + 1)
    if (!(rate > minRate)) {
      minRate = rate
      arriveTime = item.currentTime
    }
  })
  return arriveTime
}

export const calculateVolumeByArriveTime = (hourStatus, arriveTime) => {
  arriveTime = new Date(arriveTime).getTime()
  // 默认为0
  let emptyInventory = 0
  let lastArriveTime = 0
  hourStatus.forEach((item) => {
    let currentTimeTimeNum = item.currentTime.getTime()
    if (lastArriveTime < arriveTime && (currentTimeTimeNum > arriveTime || currentTimeTimeNum === arriveTime)) {
      emptyInventory = item.emptyInventory
    }
    lastArriveTime = currentTimeTimeNum
  })
  return parseInt(emptyInventory * optimalStorageRatio)
}

// 参数说明： 开始库存 有效容积 停泵库存 订单 预测销量 小时销售百分比 开始时间(Date) 结束时间(Date)
export const getHourStatus = ({startInventory, validCapacity, stopPumpCapacity, order, preSales, hourSalesRate, dataStartTime, dataEndTime}) => {
  let hourStatus = []
  // 开始时间小时数
  let startHour = dataStartTime.getHours()
  // 开始时间时间戳
  let startTime = dataStartTime.getTime()
  // 结束时间时间戳
  let endTime = dataEndTime.getTime()
  // 获取从开始时间到结束时间的小时列表 时间戳列表
  let hourList = getTimePointList(startTime, endTime, [], hourLong)
  // 前一节点库存量
  let lastInventory = startInventory
  hourList.forEach((item, index) => {
    // 前一节点时间戳
    let lastTime = index > 0 ? hourList[index - 1] : item
    // 出库升数 !!!周期不是一个小时以后需要调整修改
    let outVolume = index !== 0 ? parseInt(preSales * hourSalesRate[(startHour + index + 23) % 24] / 100) : 0
    // 入库升数
    let inVolume = 0
    let inOrder = []
    order.forEach((orderItem) => {
      let arriveTime = orderItem.arriveTime.getTime()
      // 如果订单到达时间大于上一时间点 小于或等于当前时间点 加入入库升数
      if (arriveTime > lastTime && (arriveTime < item || arriveTime === item)) {
        inVolume += orderItem.volume
        inOrder.push(orderItem)
      }
    })
    // 当前库存量 = 上一节点库存量 - 出库升数 + 入库升数
    let currentInventory = parseInt(lastInventory - outVolume + inVolume)
    // 库存最小为stopPumpCapacity
    currentInventory = currentInventory > stopPumpCapacity ? currentInventory : stopPumpCapacity
    // 空容 = 有效容积 - 当前库存
    let emptyInventory = validCapacity - currentInventory
    // 最大空容
    let maxEmptyInventory = validCapacity - stopPumpCapacity
    emptyInventory = emptyInventory < 0 ? 0 : (emptyInventory > maxEmptyInventory ? maxEmptyInventory : emptyInventory)
    let status = currentInventory < stopPumpCapacity ? 'low' : (currentInventory > validCapacity ? 'high' : 'normal')
    hourStatus.push({
      currentTime: new Date(item),
      inVolume,
      outVolume,
      emptyInventory,
      currentInventory,
      status,
      inOrder: inOrder
    })
    lastInventory = currentInventory
  })
  return hourStatus
}

export const generateChartOption = (hourStatus, validCapacity, stopPumpCapacity, piCanPeratePeriod, piChartShowXL) => {
  // x轴数据
  let xData = []
  let barData = {
    name: '销量',
    type: 'bar',
    yAxisIndex: 1,
    data: [],
    itemStyle: {
      color: '#91c6ae'
    }
  }
  // cahrt数据
  let chartData = {
    data: [],
    name: '库存量',
    showMaxMin: true,
    lines: [{
      lineType: 'y',
      value: stopPumpCapacity,
      formatter: '停泵库存 {c} L'
    },
    {
      lineType: 'y',
      value: validCapacity,
      formatter: '总罐容 {c} L'
    }]
  }
  let startX = null
  let endX = null
  let startX2 = null
  let endX2 = null
  let moreThen = false
  let maxBarData = 0
  hourStatus.forEach((item) => {
    let xDataOne = dateOperating.formatDate({date: item.currentTime, format: 'm-d hh:mm'})
    xData.push(xDataOne)
    if (xDataOne.includes('00:00')) {
      chartData.lines.push({
        lineType: 'x',
        value: xDataOne,
        formatter: function (data, a1, a2) {
          return data.data.coord[0].slice(0, 4)
        }
      })
    }
    if (piCanPeratePeriod.pass) {
      if (!(item.currentTime.getTime() > piCanPeratePeriod.perateStartTime.getTime())) {
        startX = xDataOne
      }
      if (!(item.currentTime.getTime() > piCanPeratePeriod.perateEndTime.getTime())) {
        endX = xDataOne
        if (xDataOne.includes('21:00')) {
          startX2 = xDataOne
        }
        if (xDataOne.includes('08:00')) {
          endX2 = xDataOne
        }
      }
    }
    barData.data.push(item.outVolume)
    chartData.data.push({
      value: item.currentInventory,
      emptyInventory: item.emptyInventory,
      orders: item.inOrder,
      inVolume: item.inVolume,
      outVolume: item.outVolume
    })
    maxBarData = item.outVolume > maxBarData ? item.outVolume : maxBarData
    moreThen = moreThen || (item.currentInventory > validCapacity)
  })
  if (startX && endX) {
    chartData.areas = [{
      color: 'rgba(103, 194, 58, 0.3)',
      x1: startX,
      x2: endX,
      y1: 0,
      y2: validCapacity
    }]
  }
  let chartData2 = {
    data: [],
    name: '库存量1',
    areas: [{
      color: 'rgba(0, 0, 0, 0.2)',
      x1: startX2,
      x2: endX2,
      y1: 0,
      y2: validCapacity
    }]
  }
  barData = piChartShowXL ? barData : null
  maxBarData = piChartShowXL ? maxBarData : null
  return {xData, dataList: [chartData, chartData2], barData, maxBarData, topData: validCapacity, btmData: stopPumpCapacity, maxData: (moreThen ? null : validCapacity)}
}

export const getTimePointList = (currentTime, endTime, pointList, cycle) => {
  if (!(currentTime > endTime)) {
    pointList.push(currentTime)
    return getTimePointList(currentTime + cycle, endTime, pointList, cycle)
  } else {
    return pointList
  }
}

export const dealOrder = ({piOrder, distributionOrder, routerOrder}) => {
  let orders = []
  piOrder.forEach((item) => {
    orders.push({
      arriveTime: dateOperating.formatDate({date: item.arriveTime}),
      volume: item.volume,
      type: 'pi'
    })
  })
  distributionOrder.forEach((item) => {
    orders.push({
      arriveTime: dateOperating.formatDate({date: item.arriveTime}),
      volume: item.volume,
      type: 'way'
    })
  })
  routerOrder.forEach((item) => {
    orders.push({
      arriveTime: dateOperating.formatDate({date: item.arriveTime}),
      volume: item.volume,
      type: 'way'
    })
  })
  return orders
}

// 检查数据是否完整
export const checkGasTankData = (data) => {
  let checkResult = {
    pass: true,
    msg: ''
  }
  if (data.validCapacity < 0 || data.validCapacity === 0) {
    checkResult.pass = false
    checkResult.msg += '有效容积小于等于0，'
  }
  if (data.stopPumpCapacity < 0) {
    checkResult.pass = false
    checkResult.msg += '停泵库存小于0，'
  }
  if (data.preSales < 0) {
    checkResult.pass = false
    checkResult.msg += '平均销量小于0，'
  }
  if (data.startInventory < 0) {
    checkResult.pass = false
    checkResult.msg += '期初库存小于0，'
  }
  if (data.wayHour < 0) {
    checkResult.pass = false
    checkResult.msg += '在途时间小于0，'
  }
  if (!data.collectTime) {
    checkResult.pass = false
    checkResult.msg += '采集时间为空，'
  }
  checkResult.meg = checkResult.msg.slice(0, -1)
  return checkResult
}

export const getDataPeriod = (gasDailyCollectTime, piDate, wayHour) => {
  // 取整点数据
  let dataStartTime = dateOperating.formatDate({date: dateOperating.formatDate({date: gasDailyCollectTime, format: 'yy-mm-dd hh:mm'}).slice(0, 14) + '00'})
  // 在途时间 + 配送时间 + 一天
  let dataEndTime = dateOperating.computeDay({date: piDate, days: parseInt(wayHour / workHours) + 3})
  return {dataStartTime, dataEndTime}
}

// 获取可选择送达时间段
export const getCanPeratePeriod = (piDate, wayHour) => {
  // 配送时间是明天的8点到21那到达时间
  // 在途时间 + 配送时间 + 一天
  // 最早到达日期
  let perateStartDay = dateOperating.computeDay({date: piDate, days: parseInt(wayHour / workHours)})
  // 到达那天还要开几个小时
  let startDayWorkHours = wayHour % workHours
  // 最早到达时间
  let perateStartTime = new Date(perateStartDay.getTime() + (8 + startDayWorkHours) * hourLong)
  // 最晚到达时间
  let perateEndTime = dateOperating.computeDay({date: perateStartTime, days: 1})
  return {perateStartTime, perateEndTime}
}

export const getCanChooseHourStatus = (hourStatus, canChoosePeriod) => {
  // 可用小时状态列表
  let canChooseHourStatus = []
  let waitCanChooseHourStatus = null
  hourStatus.forEach((item) => {
    if (item.currentTime.getTime() > canChoosePeriod.canChooseStartTime.getTime() && item.currentTime.getTime() < canChoosePeriod.canChooseEndTime.getTime()) {
      canChooseHourStatus.push(item)
    }
    if (item.currentTime.getTime() < canChoosePeriod.canChooseEndTime.getTime()) {
      waitCanChooseHourStatus = item
    }
  })
  canChooseHourStatus = canChooseHourStatus.length === 0 && waitCanChooseHourStatus ? [waitCanChooseHourStatus] : canChooseHourStatus
  return canChooseHourStatus
}

// 获取piorder可选时间 orderList 必须安时间排序
export const getCanChoosePeriod = (canPeratePeriod, orderList, orderIndex) => {
  let canChooseStartTime = canPeratePeriod.perateStartTime
  let canChooseEndTime = canPeratePeriod.perateEndTime
  if (orderList[orderIndex - 1]) {
    canChooseStartTime = new Date(orderList[orderIndex - 1].arriveTime)
  }
  if (orderList[orderIndex + 1]) {
    canChooseEndTime = new Date(orderList[orderIndex + 1].arriveTime)
  }
  return {canChooseStartTime, canChooseEndTime}
}



// WEBPACK FOOTER //
// ./src/cllib/pi.js